import { Stack, Text, TooltipHost } from '@fluentui/react';
import { DirectionalHint } from '@fluentui/react';
import { IC } from 'components/SVGIcon';
import { PresenceIcon } from 'kits/IconKit2';
import React from 'react';

export interface IPresencePillProps {
    usersAndVisitorsCount: {
        users: number;
        visitors: number;
    };
    color?: string;
    getPresenceTooltip: (u: number, v: number) => string;
}

const PresencePill: React.FC<IPresencePillProps> = ({ usersAndVisitorsCount, color, getPresenceTooltip }) => {
    const chosenLang = localStorage.getItem('chosenLanguage') || 'en';
    const { users, visitors } = usersAndVisitorsCount;
    const show = users > 0 || visitors > 0;
    if (!show) return null;

    return (
        <TooltipHost content={getPresenceTooltip(users, visitors)} directionalHint={DirectionalHint.topCenter}>
            <Stack
                horizontal
                verticalAlign="center"
                tokens={{ childrenGap: 4 }}
                styles={{ root: { color: color || 'white', marginLeft: 2, marginBottom: -4 } }}
            >
                <IC size={14} variant="custom" iconColor={color}>
                    <PresenceIcon />
                </IC>

                {users > 0 && (
                    <Text variant="small" style={{ color: color || 'white', marginBottom: 4 }}>
                        M{' '}
                        <Text variant="large" style={{ fontWeight: 600, color: color || 'white' }}>
                            {users}
                        </Text>
                    </Text>
                )}

                {visitors > 0 && (
                    <Text variant="small" style={{ color: color || 'white', marginBottom: 4 }}>
                        {chosenLang === 'de' ? 'B' : 'V'}{' '}
                        <Text variant="large" style={{ fontWeight: 600, color: color || 'white' }}>
                            {visitors}
                        </Text>
                    </Text>
                )}
            </Stack>
        </TooltipHost>
    );
};

export default PresencePill;
